import React, { Component } from 'react';
import styled from 'styled-components';

// import Color from '../../../../utils/colors';
import mediaWidth from '../../../../utils/mediaWidth/mediaWidth';

class Button extends Component {
    render() {
        const { className, onClick, isFilled } = this.props;
        return (
            <StyledButton
                className={className}
                onClick={onClick}
                isFilled={isFilled}
            />
        );
    }
}

const StyledButton = styled.div`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${({ isFilled }) => (isFilled ? '#0032A0' : '#FFFFFF')};
    border: 1px solid #FFFFFF;
    cursor: pointer;

    ${mediaWidth.xl} {
        width: 10px;
        height: 10px;
    };
`;

export default Button;
